var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "75px",
    height: "149px",
    viewBox: "0 0 75 149",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Help-Center",
    transform: "translate(-111.000000, -1311.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "searh",
    transform: "translate(84.000000, 794.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-37.899148, 927.043722) scale(-1, 1) rotate(36.000000) translate(37.899148, -927.043722) translate(-370.899148, 648.543722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.7535407,37.8441204 C53.8563981,39.5671036 52.7487039,41.9926118 52.6889212,44.5546905 L51.4141645,99.1863223 C51.4130438,99.2343535 51.413326,99.2824072 51.4150108,99.3304219 C51.4628035,100.692421 52.6056654,101.757796 53.9676643,101.710003 C55.4855407,101.656741 56.7055039,100.441948 56.7652129,98.9243118 L59.1444239,38.4514646 C59.1609635,38.0310745 59.0117399,37.6210042 58.7288882,37.3095618 C58.1330727,36.6535212 57.1182428,36.6046991 56.4622022,37.2005146 L55.7535407,37.8441204 Z",
    id: "Rectangle-12",
    stroke: "#5C6169",
    strokeWidth: 1.17,
    transform: "translate(55.279580, 69.247640) rotate(-30.000000) translate(-55.279580, -69.247640) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    stroke: "#5C6169",
    strokeWidth: 1.17,
    fill: "#FFFFFF",
    cx: 32.2458101,
    cy: 30.4243697,
    rx: 32.2458101,
    ry: 30.4243697
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    stroke: "#5C6169",
    strokeWidth: 1.17,
    fill: "#FFFFFF",
    cx: 32.2458101,
    cy: 30.4243697,
    rx: 26.0446927,
    ry: 24.5735294
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.248219,556.761271 C503.857182,305.86151 415.354251,201.389858 399.739428,243.346316 C319.602564,458.671132 110.937223,81.1992073 102.088929,73.7717762 C93.240634,66.3443451 77.8501743,59.1124896 58.4022557,69.2851424 C38.954337,79.4577952 33.3671992,83.0439091 30.3534887,85.3591938 C27.3397783,87.6744784 24.4920369,89.8795528 27.0180007,93.3961128 C28.7019767,95.7404861 30.7573298,96.46712 33.1840602,95.5760145 L49.7268096,86.8224691 L33.1840602,95.5760145 C32.4302542,97.7724504 32.7403876,99.8213839 34.1144603,101.722815 C35.4885331,103.624246 37.9707514,104.285179 41.5611151,103.705612 L56.399167,95.5760145 L41.5611151,103.705612 C41.1738513,106.129175 41.8696368,108.254036 43.6484716,110.080193 C45.4273064,111.90635 47.8317036,111.90635 50.8616629,110.080193 L59.8168507,105.462587 L51.9530009,109.501279 C50.5066328,111.538464 50.5066328,113.420316 51.9530009,115.146833 C53.3993691,116.87335 55.9973981,116.87335 59.7470879,115.146833 C73.0780574,107.994549 81.2840439,103.289704 84.3650475,101.032295 C87.4460511,98.7748872 88.8753815,96.4200712 88.6530387,93.9678475",
    id: "Path-5",
    stroke: "#5C6169",
    strokeWidth: 1.17,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("text", {
    id: "?",
    opacity: 0.664855072,
    transform: "translate(33.579620, 32.659079) scale(-1, 1) rotate(34.000000) translate(-33.579620, -32.659079) ",
    fontFamily: ".SFNSDisplay, .SF NS Display",
    fontSize: 36,
    fontWeight: "normal",
    letterSpacing: 1,
    fill: "#373633"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 24.0796202,
    y: 46.659079
  }, "?"))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.a093e02c16e67e9d39fa45205897b6a4.svg";
export { ForwardRef as ReactComponent };